package er.prateek.crossly.ui.screens.crossword

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.sp
import er.prateek.crossly.ui.theme.game

@Composable
fun CountdownOverlay(
    beat: String,
    modifier: Modifier = Modifier,
) {
    val colors = MaterialTheme.game
    val scale = remember(beat) { Animatable(0.35f) }
    LaunchedEffect(beat) {
        scale.snapTo(0.35f)
        scale.animateTo(
            targetValue = 1f,
            animationSpec = spring(
                dampingRatio = Spring.DampingRatioMediumBouncy,
                stiffness = Spring.StiffnessLow,
            ),
        )
    }
    val huge = beat.length == 1
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(colors.backdropTop.copy(alpha = 0.82f))
            .pointerInput(Unit) {
                awaitEachGesture {
                    while (true) {
                        awaitPointerEvent()
                    }
                }
            },
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = beat,
            color = colors.gold,
            fontWeight = FontWeight.Black,
            fontSize = if (huge) 128.sp else 56.sp,
            lineHeight = if (huge) 132.sp else 62.sp,
            textAlign = TextAlign.Center,
            modifier = Modifier.graphicsLayer {
                scaleX = scale.value
                scaleY = scale.value
            },
        )
    }
}
